import makeAttributeSetter from './makeAttributeSetter'


/**
 * Creates an override of the get() and set() that's aware of
 * the blocklist and user-specified blocking behavior.
 *
 * @param {String} attr - the name of the attribute to override
 *
 * @returns {Object}
 */
export default function createAttributeOverride(attr) {
  return {
    configurable: true,

    set: makeAttributeSetter(attr),

    get() {
      // The alternation is crucial (sometimes). An element's
      // `src` property cannot be `null`--it has to be an empty
      // string. But `getAttribute()` may return null.
      return this.getAttribute(attr) || ''
    },
  }
}
